import type { FaireProductEntity } from "../../entity_types/product";

export const p_hucyhj6qqs: FaireProductEntity = {
  token: "p_hucyhj6qqs",
  type: "product",
  name: "Pistachio Walnut Fudge with Home-Roasted Walnuts",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/04c676ebd95afcce3b0148fa12e49c2986bb983ecd0b1dc4d1f3513e3e95da97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3e885f4ff8a5399cd2d31f6b7586a44ba74634294cb5ffba57ba50ba130522c.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "We use lots of crispy California walnuts in our Pistachio Walnut Fudge to give a noticeable crunch with every bite. The pistachio flavor is quite unique and blends beautifully with our vanilla fudge. FREE SHIPPING on all orders over $55. \n\nWe’re sorry, but we do not use pistachio nuts as they are too hard to crack and too costly to buy already shelled.\n\nPistachio Walnut Fudge in a 1/2 pound resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:45.870Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
